export default __webpack_public_path__ + "static/media/HRM.8907322f.svg";